import React, { useState, useEffect } from 'react';
import Table from './Table'; 
import { styles } from './styles'; 
const ServiceRequest = () => {
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] =  useState('');
  const [emailSearch, setEmailSearch] = useState('');

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await fetch('https://backend.pmc-group.uk/api/requests');
        const data = await response.json();
        console.log(data); 
        if (Array.isArray(data)) {
          setRequests(data);
        } else {
          console.error('Expected an array of requests');
        }
      } catch (error) {
        console.error('Error fetching requests:', error);
      }
    };

    fetchRequests();
  }, []);

  useEffect(() => {
    filterRequests();
  }, [startDate, endDate, emailSearch, requests]);

  const filterRequests = () => {
    let filtered = requests;

    if (startDate) {
      filtered = filtered.filter(request => new Date(request.date) >= new Date(startDate));
    }

    if (endDate) {
      filtered = filtered.filter(request => new Date(request.date) <= new Date(endDate));
    }

    if (emailSearch) {
      filtered = filtered.filter(request => request.email.toLowerCase().includes(emailSearch.toLowerCase()));
    }

    setFilteredRequests(filtered);
  };

  return (
    <div className='p-0 m-0 box-border'>
      <div className='w-[98%] mx-auto p-8 py-2 bg-white rounded-xl'>
        <div className='py-1 px-2'>
          <div className='flex justify-between items-center p-2'>
            <div className='text-4xl font-semibold text-blue-700' style={styles.interText}>
              Service Request
            </div>
            <div className='flex items-center border border-gray-300 rounded-lg shadow-sm bg-white focus-within:ring-2 focus-within:ring-blue-500 transition'>
              <div className='flex items-center py-3 px-4 border-r border-gray-300'>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" className='w-5 h-5 mr-1 text-blue-700'>
                  <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m16.893 16.92l3.08 3.08m-.889-8.419c0 4.187-3.383 7.581-7.555 7.581c-4.173 0-7.556-3.394-7.556-7.58C3.973 7.393 7.356 4 11.528 4c4.173 0 7.556 3.394 7.556 7.581" />
                </svg>
                <span className='text-sm font-medium text-blue-700'>
                  Email
                </span>
              </div>
              <input
                type="text"
                className='w-full p-3 text-sm font-semibold text-blue-700 outline-none rounded-r-lg'
                value={emailSearch}
                onChange={(e) => setEmailSearch(e.target.value)}
                placeholder="Search by email"
                style={styles.robotoCenter}
              />
            </div>
          </div>
          <Table requests={filteredRequests} />
          <div className='flex justify-end p-2'>
            <div className='bg-gray-300 mr-3 cursor-pointer rounded-full'>
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path fill="black" d="M17 11H9.41l3.3-3.29a1 1 0 1 0-1.42-1.42l-5 5a1 1 0 0 0-.21.33a1 1 0 0 0 0 .76a1 1 0 0 0 .21.33l5 5a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42L9.41 13H17a1 1 0 0 0 0-2" />
              </svg>
            </div>
            <div className='bg-gray-300 cursor-pointer rounded-full'>
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                <path fill="black" d="M17.92 11.62a1 1 0 0 0-.21-.33l-5-5a1 1 0 0 0-1.42 1.42l3.3 3.29H7a1 1 0 0 0 0 2h7.59l-3.3 3.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l5-5a1 1 0 0 0 .21-.33a1 1 0 0 0 0-.76" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceRequest;